import { render } from "./SocialBar.vue?vue&type=template&id=16c2c1cc&scoped=true"
import script from "./SocialBar.vue?vue&type=script&lang=js"
export * from "./SocialBar.vue?vue&type=script&lang=js"

import "./SocialBar.vue?vue&type=style&index=0&id=16c2c1cc&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c2c1cc"]])

export default __exports__